import axios from 'axios';

export const getNotificationCount = ({ navigationApiUrl, memberUuid }) => {
    const url = `${navigationApiUrl}/v4/notifications`;

    return axios.get(url, { params: { memberUuid } })
        .then(res => res.data)
        .catch(() => ({}));
};
